import { useTranslation } from 'react-i18next';

const useCtaURLBuilder = (marketType: string) => {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage;

  const isQaPage = window.location.hostname.startsWith('qa');

  const isLocalHost = window.location.host.includes('localhost');

  const isUSProd = window.location.hostname === 'www.audiusa.com';
  const isCAProd = window.location.hostname === 'www.audi.ca';

  if (isQaPage && marketType === 'CAN') return `https://qa.audi.ca/${lang}/inventory/vehicle/`;
  if (isQaPage && marketType === 'USA') return `https://qa.audiusa.com/en/inventory/vehicle/`;

  if (isCAProd) return `https://www.audi.ca/${lang}/inventory/vehicle/`;
  if (isUSProd) return `https://www.audiusa.com/en/inventory/vehicle/`;

  if (isLocalHost)
    return marketType === 'CAN'
      ? `https://www.audi.ca/${lang}/inventory/vehicle/`
      : `https://www.audiusa.com/en/inventory/vehicle/`;

  const url = window.location.href;
  // For Tier 3 - Canadian - French
  if (marketType === 'CAN' && lang === 'fr') {
    const stockIndex = url.indexOf('inventaire');
    const finalUrl = url.substring(0, stockIndex);
    return `${finalUrl}inventaire/vehicule/`;
  }
  // For Tier 3 pages,
  const inventoryIndex = url.indexOf('inventory');
  const finalHostUrl = url.substring(0, inventoryIndex);

  return `${finalHostUrl}inventory/vehicle/`;
};

export default useCtaURLBuilder;
